module.exports = __webpack_public_path__ + "img/2_170.d01ab530.png";